import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import Service from './service';
import { getServicesUrl } from '../../setup';

var Common =
/*#__PURE__*/
function (_Service) {
  _inherits(Common, _Service);

  function Common() {
    _classCallCheck(this, Common);

    return _possibleConstructorReturn(this, _getPrototypeOf(Common).apply(this, arguments));
  }

  _createClass(Common, null, [{
    key: "getGeneralSettings",
    value: function getGeneralSettings() {
      return Service.getRequest("".concat(getServicesUrl(), "/settings?group=General"), {
        isSecure: true
      });
    }
  }, {
    key: "getSettings",
    value: function getSettings(group) {
      var queryString = group !== undefined ? "?group=".concat(group) : '';
      return Service.getRequest("".concat(getServicesUrl(), "/settings").concat(queryString), {
        isSecure: true
      });
    }
  }, {
    key: "getGlobalSettingByGroupAndKey",
    value: function getGlobalSettingByGroupAndKey(group, key) {
      return Service.getRequest("".concat(getServicesUrl(), "/settings/").concat(group, "/").concat(key), {
        isSecure: true
      });
    }
  }, {
    key: "getNewsSettings",
    value: function getNewsSettings() {
      return new Promise(function (resolve) {
        Common.getGeneralSettings().then(function (response) {
          resolve(response.data.find(function (item) {
            return item.Key === 'NewsAssetTypeId';
          }));
        });
      });
    }
  }, {
    key: "getCampaignsCurrentConfiguration",
    value: function getCampaignsCurrentConfiguration() {
      var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
      return Service.getRequest("".concat(getServicesUrl(), "/campaigns/current/configuration?language=").concat(language), {
        isSecure: true
      });
    }
  }, {
    key: "getAssetClasses",
    value: function getAssetClasses(language) {
      return Service.getRequest("".concat(getServicesUrl(), "/assetclasses/").concat(language), {
        isSecure: true
      });
    }
  }, {
    key: "getSectors",
    value: function getSectors(language) {
      return Service.getRequest("".concat(getServicesUrl(), "/sectors/").concat(language), {
        isSecure: true
      });
    }
  }, {
    key: "getSecurityTypes",
    value: function getSecurityTypes(language) {
      return Service.getRequest("".concat(getServicesUrl(), "/securitytypes/").concat(language), {
        isSecure: true
      });
    }
  }, {
    key: "getCountries",
    value: function getCountries(language) {
      return Service.getRequest("".concat(getServicesUrl(), "/countries/").concat(language), {
        isSecure: true
      });
    }
  }, {
    key: "getLanguages",
    value: function getLanguages(language) {
      return Service.getRequest("".concat(getServicesUrl(), "/languages/").concat(language), {
        isSecure: true
      });
    }
  }, {
    key: "getSeverityLevels",
    value: function getSeverityLevels() {
      return Service.getRequest("".concat(getServicesUrl(), "/severity-levels"), {
        isSecure: true
      });
    }
  }, {
    key: "getRecurrenceTypes",
    value: function getRecurrenceTypes() {
      return Service.getRequest("".concat(getServicesUrl(), "/recurrencetype"), {
        isSecure: true
      });
    }
  }, {
    key: "getRiskCategory",
    value: function getRiskCategory(id) {
      return Service.getRequest("".concat(getServicesUrl(), "/riskcategories/").concat(id), {
        isSecure: true
      });
    }
  }, {
    key: "getRiskCategories",
    value: function getRiskCategories(language) {
      return Service.getRequest("".concat(getServicesUrl(), "/riskcategories?language=").concat(language), {
        isSecure: true
      });
    }
  }, {
    key: "getRiskCategoriesByProduct",
    value: function getRiskCategoriesByProduct(productId, language) {
      return Service.getRequest("".concat(getServicesUrl(), "/products/").concat(productId, "/riskcategories?language=").concat(language), {
        isSecure: true
      });
    }
  }]);

  return Common;
}(Service);

export default Common;